var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CHIP_ENTITY_TYPE } from '../../constants/chipConstants';
import { EditorState, Modifier, SelectionState } from 'draft-js';
import { useLocalChipCollectionState } from './useLocalChipCollectionState';
export var useChipHelpers = function (editorState, setEditorState, referenceCollection, setReferenceCollection, onChipClick) {
    var _a = useLocalChipCollectionState(editorState, referenceCollection, setReferenceCollection), chipCollection = _a[0], setChipCollection = _a[1];
    var addChip = function (chipReference) {
        addChipReferenceToCollectionIfMissing(chipReference);
        addChipEntity(chipReference);
    };
    var addChipEntity = function (chipReference) {
        var chipData = { id: chipReference.id, name: chipReference.name, objectType: chipReference.objectType };
        // Create Entity
        var startContentState = editorState.getCurrentContent();
        var startSelection = editorState.getSelection();
        var contentStateWithEntity = startContentState.createEntity(CHIP_ENTITY_TYPE, 'IMMUTABLE', chipData);
        // Insert Entity into content
        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        var modifyText = startSelection.isCollapsed() ? Modifier.insertText : Modifier.replaceText;
        var contentStateWithEntityInserted = modifyText(contentStateWithEntity, startSelection, ' ', undefined, entityKey);
        // Set focus after newly inserted Entity
        var contentStateWithFocusAfterEntity = contentStateWithEntityInserted.merge({
            selectionBefore: startSelection,
            selectionAfter: contentStateWithEntityInserted.getSelectionAfter().set('hasFocus', true)
        });
        var editorStateWithFocusAfterEntity = EditorState.push(editorState, contentStateWithFocusAfterEntity, 'insert-fragment');
        // Update Editor State
        setEditorState(editorStateWithFocusAfterEntity);
    };
    var addChipReferenceToCollectionIfMissing = function (newReference) {
        if (!chipCollection.find(function (chip) { return chip.id === newReference.id && chip.objectType === newReference.objectType; })) {
            setChipCollection(__spreadArray(__spreadArray([], chipCollection, true), [newReference], false));
        }
    };
    var removeChip = function (blockKey, entityStart, entityEnd) {
        // Remove Entity from Content
        var content = editorState.getCurrentContent();
        var entitySelection = SelectionState.createEmpty(blockKey)
            .merge({
            anchorOffset: entityStart,
            focusOffset: entityEnd,
        });
        var contentStateWithoutEntity = Modifier.removeRange(content, entitySelection, 'backward');
        var editorStateWithoutEntity = EditorState.push(editorState, contentStateWithoutEntity, 'remove-range');
        // Removing Entity via click on that Entity blurs the editor and loses selection. This restores focus/selection.
        var selectionAfterRemoval = editorStateWithoutEntity.getSelection();
        var editorStateWithRestoredSelection = EditorState.forceSelection(editorStateWithoutEntity, selectionAfterRemoval);
        // Update Editor State
        setEditorState(editorStateWithRestoredSelection);
    };
    var getChipReference = function (chipData) {
        return chipCollection === null || chipCollection === void 0 ? void 0 : chipCollection.find(function (reference) { return reference.id === (chipData === null || chipData === void 0 ? void 0 : chipData.id) && reference.objectType === (chipData === null || chipData === void 0 ? void 0 : chipData.objectType); });
    };
    return {
        addChip: addChip,
        removeChip: removeChip,
        getChipReference: getChipReference,
        onChipClick: onChipClick,
    };
};
//# sourceMappingURL=useChipHelpers.js.map